
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ValidationProvider } from 'vee-validate';
import FormGroup from "@/components/form/FormGroupNew.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import FormSelect from "@/components/form/FormSelectNew.vue";
import FormToggle from "@/components/form/FormToggle.vue";
import GET_LANGUAGES from "@/apollo/autocomplete-queries/GetLanguages.gql";
import _ from 'lodash';

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormInputGroup,
    FormSelect,
    FormToggle
  },
  apollo: {
    languages: {
      query: GET_LANGUAGES,
      variables() {
        return {
          where: {},
          limit: 1000
        };
      },
      update(data) {
        return data.language || [];
      }
    }
  }
})
export default class LanguageCommunication extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};
  languages: any[] = [];

  created() {
    this.localFormData = _.cloneDeep(this.formData);
  }

  get languageOptions() {
    const options = this.languages.map(language => ({
      label: language.name,
      value: language.name
    }));

    return options;
  }

  @Watch('formData', { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    this.localFormData = _.cloneDeep(newVal);
    this.ensureProperValueMapping();
  }

  @Watch('languages', { immediate: true })
  onLanguagesChange(newVal: any[]) {
    this.ensureProperValueMapping();
  }

  ensureProperValueMapping() {
    if (this.languages.length > 0 && this.localFormData) {

      // Force Vue to reactively update the values by re-setting them
      this.$nextTick(() => {
        // Check if the stored values exist in the language options
        if (this.localFormData.communication_languages_spoken) {
          const storedValue = this.localFormData.communication_languages_spoken;
          
          // Handle both array and single string values (for backward compatibility)
          if (Array.isArray(storedValue)) {
            // Already an array, validate each value exists in options
            const validLanguages = storedValue.filter(lang => 
              this.languages.some(option => option.name === lang)
            );
            this.$set(this.localFormData, 'communication_languages_spoken', validLanguages);
          } else if (typeof storedValue === 'string') {
            // Convert single string to array
            const foundLanguage = this.languages.find(lang => lang.name === storedValue);
            if (foundLanguage) {
              this.$set(this.localFormData, 'communication_languages_spoken', [storedValue]);
            }
          }
        }
        
        if (this.localFormData.preferred_language) {
          const storedValue = this.localFormData.preferred_language;
          const foundLanguage = this.languages.find(lang => lang.name === storedValue);
          
          if (foundLanguage) {
            // Try setting as both string and object format
            this.$set(this.localFormData, 'preferred_language', storedValue);
          }
        }
      });
    }
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit('update:formData', this.localFormData);
  }
}
